module.exports = __webpack_public_path__ + "static/media/Camera14.35fb16b2.jpg";